import React, { Fragment } from 'react';
import { Button } from 'prixa-design-kit/dist';
import googleIcon from '../../../img/google-icon.png';

export const GoogleSignUp = () => {
  return (
    <Fragment>
      <div className="margin-baseY">
        <span className="prixa-lineonsides">atau</span>
      </div>
      <Button size="xLarge" variant="outline" style={{ width: '100%', position: 'relative' }}>
        <img
          loading="lazy"
          height="55%"
          alt="google"
          src={googleIcon}
          style={{ position: 'absolute', left: 0, marginLeft: '16px', maxHeight: '55%' }}
        />
        Lanjutkan dengan Google
      </Button>
    </Fragment>
  );
};
